import PropTypes from 'prop-types';
import React from 'react';
import { FILE_UPLOAD_GUIDANCE } from '../../constants';

function ClaimFileHeader({ claim, isOpen, isChampvaFlow }) {
  const filesMeta = claim?.attributes?.claimStatusMeta?.files;
  const headerTitle = filesMeta?.headerTitle || 'Claim files';

  const getIntroText = () => {
    if (isChampvaFlow) {
      return null;
    }

    if (isOpen) {
      return FILE_UPLOAD_GUIDANCE;
    }

    return (
      <p className="vads-u-margin-top--1 vads-u-margin-bottom--3 va-introtext">
        You can see the files associated with this claim.
      </p>
    );
  };

  return (
    <div className="claim-file-header-container">
      <h2 className="tab-header vads-u-margin-y--0">{headerTitle}</h2>
      {getIntroText()}
    </div>
  );
}

ClaimFileHeader.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  claim: PropTypes.object,
  isChampvaFlow: PropTypes.bool,
};

export default ClaimFileHeader;
